import { Component, OnInit } from '@angular/core';
import { Button, ButtonColor, ButtonSize } from 'app/store/models/button.model';

@Component({
  selector: 'app-user-replay-listing',
  templateUrl: './user-replay-listing.component.html',
  styleUrls: ['./user-replay-listing.component.scss'],
})
export class UserReplayListingComponent implements OnInit {
  buttonProperties: Button = {
    color: ButtonColor.BLUE,
    size: ButtonSize.SMALL,
    text: 'Edit',
    style: 'filled',
  };

  constructor() {}

  ngOnInit() {}

  getButtonRoute(type: string) {
    return [`/contents/user_replies/${type}/edit`];
  }
}
